import { render, staticRenderFns } from "./SaleDetails.vue?vue&type=template&id=4bb23876&scoped=true&"
import script from "./SaleDetails.vue?vue&type=script&lang=ts&"
export * from "./SaleDetails.vue?vue&type=script&lang=ts&"
import style0 from "./SaleDetails.vue?vue&type=style&index=0&id=4bb23876&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../backups/absys-worktrees/2026-09-12-colomer-web/src/web/AbsysERP.WebApi/ClientApp/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb23876",
  null
  
)

export default component.exports